import { jsx as a } from "../../../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import { memo as s } from "../../../../../external/preact/compat/dist/compat.module.js";
import l from "../../calendar/facade/index.js";
import { Fragment as i } from "../../../../../external/preact/dist/preact.module.js";
import { isFunction as c } from "../../../../../utils/value/is.js";
const e = ({ config: r, grid: { controls: t }, renderer: o }) => r.controls === l.controls.NONE || !c(o) ? null : /* @__PURE__ */ a(i, { children: t.map(([n, m]) => o(n, m)) }), g = s(e);
export {
  g as default
};
